function encodePassword(_password) {
	const seed = _password.substr(0, 4),
		arrSeed = seed.split('');

	let b64Password = Buffer.from(_password).toString('base64');

	b64Password = `${arrSeed[0]}${b64Password}`;
	b64Password = `${b64Password.substr(0, 4)}${
		arrSeed[1] || '.'
	}${b64Password.substr(4)}`;
	b64Password = `${b64Password.substr(0, 2)}${
		arrSeed[2] || '.'
	}${b64Password.substr(2)}`;
	b64Password = `${b64Password.substr(0, 6)}${
		arrSeed[3] || '.'
	}${b64Password.substr(6)}`;

	b64Password = Buffer.from(b64Password).toString('base64');

	return b64Password;
}

function decodePassword(_password) {
	try {
		_password = window.atob(_password);
		_password = `${_password.substr(0, 6)}${_password.substr(7)}`;
		_password = `${_password.substr(0, 2)}${_password.substr(3)}`;
		_password = `${_password.substr(0, 4)}${_password.substr(5)}`;
		_password = `${_password.substr(1)}`;
		_password = window.atob(_password);
	} catch (error) {
		console.error(error);
	}

	return _password;
}
export default { encode: encodePassword, decode: decodePassword };
